var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGabiUserDefaulfAvatar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 60 60"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E9B372;}\n\t.st1{fill:#130C0E;}\n\t.st2{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M43.7,13.9C42.6,6.2,36,0.2,28,0.2c-1.3,0-2.4,1.1-2.4,2.4S26.7,5,28,5s2.4,1.1,2.4,2.4S29.3,9.8,28,9.8v0.1 c-12.9,1-23.1,11.9-23.1,25c0,8.2,3.9,15.4,9.9,20c0,0,0.1,0.1,0.4,0.3c1.6,1.2,3.3,2.1,5.1,2.9c0.3,0.2,0.6,0.3,0.9,0.4 c0.2,0,0.3,0.1,0.5,0.1c0.2,0.1,0.3,0.1,0.5,0.2c0.1,0,0.2,0.1,0.3,0.1c0.3,0.1,0.6,0.2,0.9,0.3c0.1,0,0.1,0,0.2,0 c0.5,0.1,1,0.3,1.5,0.4c0.1,0,0.2,0,0.2,0c0.2,0,0.5,0.1,0.7,0.1c0.1,0,0.2,0,0.3,0.1c0.1,0,0.2,0,0.3,0c0.1,0,0.2,0,0.3,0 c0.1,0,0.2,0,0.3,0c0.2,0,0.4,0,0.7,0.1c0.1,0,0.2,0,0.3,0c0.1,0,0.2,0,0.3,0h0.1c0.4,0,0.8,0,1.2,0l0,0c0.1,0,0.1,0,0.2,0l0,0l0,0 c13.9,0,25.1-11.2,25.1-25.1C55.2,26.1,50.6,18.3,43.7,13.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M26.9,30.4c0.8,0.4,0.9,1,0.9,1.6c0.1,2.1-0.5,4-2,5.6c-1,1-1,1.3,0,2.4c0.3,0.3,0.7,0.6,0.9,0.9 c0.1,0.2,0.2,0.5,0.1,0.8c-0.1,0.2-0.4,0.3-0.6,0.3c-1.4-0.3-2.1-1.3-2.7-2.4c-0.5-0.9-0.4-1.9,0.4-2.5c1.8-1.5,2.3-3.5,2.7-5.7 C26.6,31.1,26.8,30.8,26.9,30.4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M14.7,35.9c0.3-0.7,0.5-1.4,0.9-2.1c0.4-0.7,1.4-0.7,1.8-0.1c0.9,1.4,1,3-0.1,4.1c-0.4,0.4-0.9,0.7-1.5,0.5 c-0.6-0.3-0.9-0.8-0.9-1.5c0-0.3,0-0.6,0.1-0.9C14.8,35.9,14.7,35.9,14.7,35.9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M39,36.9c-0.2,0.4-0.4,1.1-0.8,1.6C37.5,39.2,36.5,39,36,38c-0.5-1.2-0.4-2.3,0.5-3.4c0.3-0.4,0.8-0.8,1.3-0.6 c0.6,0.2,1,0.6,1,1.2C39,35.8,39,36.2,39,36.9z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M39.3,27.7c1,0.1,2,0.2,2.9,0.4c0.4,0.1,0.8,0.5,0.8,0.7s-0.5,0.6-0.8,0.6c-2.1-0.1-4.3-0.3-6.4-0.6 c-0.3,0-0.7-0.5-0.7-0.7s0.6-0.5,1-0.5C37.1,27.5,38.2,27.7,39.3,27.7L39.3,27.7z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M16.4,26c-1,0.2-1.9,0.5-2.9,0.6c-0.4,0-0.9-0.2-1-0.4c-0.1-0.2,0.3-0.7,0.6-0.8c2.1-0.6,4.1-1.1,6.2-1.6 c0.3-0.1,0.9,0.2,0.9,0.5c0,0.2-0.4,0.7-0.8,0.8C18.5,25.4,17.4,25.6,16.4,26C16.4,25.9,16.4,25.9,16.4,26z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M20.3,47.2c1.3-0.2,2.6-0.4,3.8-0.6c2.5-0.4,4.9-0.8,7.4-1.2c0.7-0.1,1.5-0.2,1.9,0.2s-0.2,0.8-0.7,1.1 c-2.5,1.9-6.9,2.6-9.9,2.2C21.5,48.8,20.6,48.2,20.3,47.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGabiUserDefaulfAvatar);
export default __webpack_public_path__ + "static/media/gabiUserDefaulfAvatar.f10b828f6ecc274a6e42a9d472db0e4e.svg";
export { ForwardRef as ReactComponent };